import type { CsvRow, MonthDay } from "../types";
import { compareMonthDay, dateToMonthDay } from "./monthDay";

// Filter rows by a month-day window. Handles year-wrap (Oct→May).
// Bounds are inclusive.
//   start === null && end === null → return all rows
//   start only                     → keep rows where md(r) >= start
//   end only                       → keep rows where md(r) <= end
//   both, non-wrap                 → keep rows where start <= md(r) <= end
//   both, wrap (start > end)       → keep rows where md(r) >= start OR md(r) <= end
export function filterByMonthDayRange(
  rows: CsvRow[],
  start: MonthDay | null,
  end: MonthDay | null
): CsvRow[] {
  if (!start && !end) return rows;

  const isWrap = !!(start && end && compareMonthDay(start, end) > 0);

  return rows.filter((row) => {
    const md = dateToMonthDay(row.timestamp);
    if (isWrap) {
      return compareMonthDay(md, start!) >= 0 || compareMonthDay(md, end!) <= 0;
    }
    if (start && compareMonthDay(md, start) < 0) return false;
    if (end && compareMonthDay(md, end) > 0) return false;
    return true;
  });
}
